import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_bluetooth_state.js";
//#region src/kiosk_bluetooth_state_helper.ts
var kiosk_bluetooth_state_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(bluetoothState) {
	switch (bluetoothState) {
		case 0: return "unknown";
		case 1: return "resetting";
		case 2: return "unsupported";
		case 3: return "unauthorized";
		case 4: return "powered off";
		case 5: return "powered on";
	}
}
//#endregion
export { kiosk_bluetooth_state_helper_exports, name };

//# sourceMappingURL=kiosk_bluetooth_state_helper.js.map